import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'components/ui';
import skuUtils from 'utils/Sku';
import skuHelpers from 'utils/skuHelpers';
import userUtils from 'utils/User';
import languageLocale from 'utils/LanguageLocale';
import Actions from 'Actions';
import { wrapFunctionalComponent } from 'utils/framework';
import { HEADER_VALUE } from 'constants/authentication';
import CallToActionEN from 'components/ProductPage/CallToAction/locales/CallToAction_en_US';
import CallToActionFR from 'components/ProductPage/CallToAction/locales/CallToAction_fr_CA';

const getText = languageLocale.getLocalisedDataFromResource(CallToActionEN, CallToActionFR);

const BiExclusiveMsg = ({ sku }) => {
    const dispatch = useDispatch();

    const showSignInModal = useCallback(
        () => dispatch(Actions.showSignInModal({ isOpen: true, extraParams: { headerValue: HEADER_VALUE.USER_CLICK } })),
        [dispatch]
    );

    const showBiRegisterModal = useCallback(() => dispatch(Actions.showBiRegisterModal({ isOpen: true })), [dispatch]);

    if (!skuUtils.isBiExclusive(sku) || skuHelpers.isBiQualify(sku)) {
        return null;
    }

    const biExclusiveLevel = sku.biExclusiveLevel === skuUtils.biExclusiveLevels.BI ? 'an Insider' : `${sku.biExclusiveLevel}`;
    const isSignedIn = userUtils.isSignedIn();

    return (
        <>
            {getText('userLabelText', [biExclusiveLevel])}
            {isSignedIn || (
                <>
                    {' '}
                    <Link
                        color='blue'
                        underline={true}
                        padding={2}
                        margin={-2}
                        onClick={showSignInModal}
                        children={getText('signIn')}
                    />{' '}
                    {getText('or')}
                </>
            )}
            {isSignedIn && !userUtils.isBI() && (
                <>
                    {' '}
                    <Link
                        color='blue'
                        underline={true}
                        padding={2}
                        margin={-2}
                        onClick={showBiRegisterModal}
                        children={getText('signUp')}
                    />{' '}
                    {getText('or')}
                </>
            )}{' '}
            <Link
                color='blue'
                underline={true}
                padding={2}
                margin={-2}
                href='/profile/BeautyInsider'
                children={getText('learnMore')}
            />
        </>
    );
};

export default wrapFunctionalComponent(BiExclusiveMsg, 'BiExclusiveMsg');
